"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperCurrentLabelMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class ProgressStepperCurrentLabelMixin */
/** @method */
var ProgressStepperCurrentLabelMixin = function ProgressStepperCurrentLabelMixin(props) {
  return (0, _styledToken.default)('ProgressStepper.label.marginTop.current', function (marginTop) {
    if (marginTop === void 0) {
      marginTop = 0;
    }
    return (0, _styledComponents.css)(["margin-top:", "px;"], marginTop);
  })(props);
};
exports.ProgressStepperCurrentLabelMixin = ProgressStepperCurrentLabelMixin;